/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from '../../../helpers/Link';

const API_URL = process.env.REACT_APP_CMS;
const PRICING_PATH = 'estimation';

const OfferDetailsCta = ({
    openPage, language, item
}) => (
    <div className="offer-details-cta-container">
        <div className="layout">
            <div className="offer-details-cta-content">
                {
                    item.ctas.map((elem, index) => (
                        <Link
                          key={ index }
                          openPage={ openPage }
                          language={ language }
                          page={ elem.type === 'file' ? `${ API_URL }/assets/${ elem.file }` : elem.translations.path }
                          query={ elem.translations.path === PRICING_PATH && elem.query ? { pricing: elem.query } : {} }
                          className={
                                cx(
                                    'offer-details-cta',
                                    { 'container-2': item.ctas.length === 2 },
                                    { 'container-3': item.ctas.length >= 3 && item.ctas.length % 3 === 0 },
                                    { 'container-4': item.ctas.length >= 3 && item.ctas.length % 3 === 1 },
                                    { 'container-5': item.ctas.length >= 3 && item.ctas.length % 3 === 2 }
                                )
                              }
                        >
                            <div className="offer-details-cta-item" key={ index }>
                                <span
                                  className="offer-details-cta-icon"
                                >
                                    <img className="offer-details-cta-icon-src" src={ `${ API_URL }/assets/${ elem.icon }` } alt={ elem.translations.text }/>
                                </span>
                                <p className="offer-details-cta-text">{ elem.translations.text }</p>
                            </div>
                        </Link>
                    ))
                }
            </div>
        </div>
    </div>
);

OfferDetailsCta.propTypes = {
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    item: PropTypes.shape().isRequired
};

export default OfferDetailsCta;



// WEBPACK FOOTER //
// ./src/components/content/offer/details/OfferDetailsCta.jsx